export default __webpack_public_path__ + "static/media/bot-lying.5feeac8e.jpg";